import type { KeyboardEvent } from "react";

export type ActivatableOptions = { label?: string; role?: "button" | "link" };

/**
 * Props that make a clickable legacy `View` (a `div` on web) a real control: a
 * role, a name, a Tab stop, and Enter (and Space, for a button) to activate it.
 */
export function activatable(
  onActivate: () => void,
  { label, role = "button" }: ActivatableOptions = {},
) {
  return {
    role,
    "aria-label": label,
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: (event: KeyboardEvent) => {
      if (event.key === "Enter" || (role === "button" && event.key === " ")) {
        event.preventDefault();
        onActivate();
      }
    },
  };
}
